export default __webpack_public_path__ + "static/media/heroic_intel.95712615.png";